import type { ReactNode } from 'react';

interface HudHintProps {
  children: ReactNode;
}

/**
 * Faint inline copy inside a HUD row — "tap a token + drag to reposition",
 * "drag from a player to bind a run", "5 runs", etc. Visually deprioritised
 * vs. the chip buttons but still readable; doesn't catch pointer events.
 */
export function HudHint({ children }: HudHintProps) {
  return <span className="thud__hint">{children}</span>;
}
